import React from "react";
import PropTypes from "prop-types";

import "screens/terms-and-conditions/component/view.scss";

const PartnerTermsNeueHouseView = ({ reference }) => (
  <div className="bg-white">
    <article className="terms-and-conditions" ref={reference}></article>
  </div>
);

PartnerTermsNeueHouseView.propTypes = {
  reference: PropTypes.object,
};

export default PartnerTermsNeueHouseView;
